import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import BookmarkLogo from "~/components/article/article-render/live-article/bookmark.svg";

export const Container = styled.div`
  display: grid;
  grid:
    "icon time" min-content
    ". text" min-content
    / 12px 1fr;
  gap: 2px 8px;
`;

export const StyledBookmarkLogo = styled(BookmarkLogo)`
  grid-area: icon;
`;

export const Time = styled.div`
  grid-area: time;

  color: #000000;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

export const Text = styled.div`
  grid-area: text;

  color: #979797;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 21px;
`;
